<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps({
  didCheck: { type: Boolean, default: false },
  checkSuccessful: { type: Boolean, default: false },
})

</script>

<template>
  <div class="form-item">
    <slot name="default">Your input element needs to go into the default slot.</slot>
    <div class="indicator good" v-if="didCheck && checkSuccessful"><slot name="good">✅</slot></div>
    <div class="indicator bad" v-if="didCheck && !checkSuccessful"><slot name="bad">❌</slot></div>
  </div>
</template>

<style scoped>
.form-item {
  position: relative;
}

.form-item .indicator {
  position: absolute;
  bottom: 15px;
  right: 20px;
}
</style>

<!--

.form-item .indicator {
  opacity: 0;
}

/* .form-item.success input {
  border: 1px solid rgb(58, 145, 58);
} */

.form-item.success .indicator {
  color: rgb(58, 145, 58);
}

.form-item.success i.fa-check-circle{
  opacity: 1;
}

.form-item.fail input {
  border: 1px solid rgb(145, 58, 58);
}

.form-item.fail .indicator {
  color: rgb(145, 58, 58);
}

.form-item.fail i.fa-times-circle{
  opacity: 1;
}

-->
